import React from 'react';
import Spinner from '@atlaskit/spinner';

const AuthLoadingScreen = (): React.JSX.Element => {
	return (
		<div
			data-testid="auth-loading-screen"
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				width: '100vw',
				backgroundColor: 'elevation.surface',
			}}
		>
			<Spinner size={150} />
		</div>
	);
};

export default AuthLoadingScreen;
